import Bowser from 'bowser';

export default function getBrowser(): string {
  const parser = Bowser.getParser(window.navigator.userAgent);

  return parser.getBrowserName() ?? 'unknown';
}
